import React from 'react';
import './DonationPage.css';

import { Donation, Heading, PageTitle } from '../../../components';
import { donations } from '../../../constants';



const DonationPage = () => {

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Donations'} page={'Donations'} />

      <section className='donations'>

        {/* Section heading */}
        <Heading title={'Our Donations'} subTitle={'Community Support'} />

        <div className='box-container'>

          {/* Map over the donations array to render each Donation */}
          {donations.map((donation) => { 
            return (
              <Donation key={donation.id} donation={donation} />
            );
          })}

        </div>

      </section>

    </>

  )
}

export default DonationPage;